// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"IndeterminateCheckbox_checkbox__3CPD8"};